import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import { Box, IconButton, Tooltip, Typography, TypographyProps } from '@mui/material';
import React from 'react';
import { useClipboard } from 'use-clipboard-copy';

interface Props {
  caption?: string | null;
  variant?: TypographyProps['variant'];
  color?: TypographyProps['color'];
  alwaysShowCopyButton?: boolean;
}

const CopyableChartCaption: React.FC<Props> = ({
  caption,
  variant = 'caption',
  color = 'text.secondary',
  alwaysShowCopyButton = false,
}) => {
  const clipboard = useClipboard({ copiedTimeout: 1200 });

  if (!caption) {
    return null;
  }

  return (
    <Box
      sx={{
        position: 'relative',
        pr: 4.5,
        minWidth: 0,
        '&:hover .copy-chart-caption-btn': {
          opacity: 1,
        },
      }}
    >
      <Typography variant={variant} color={color} sx={{ display: 'block', minWidth: 0 }}>
        {caption}
      </Typography>
      <Tooltip title={clipboard.copied ? 'Copied!' : 'Copy chart caption'}>
        <IconButton
          className="copy-chart-caption-btn"
          size="small"
          aria-label="Copy chart caption"
          onClick={(event) => {
            event.stopPropagation();
            clipboard.copy(caption);
          }}
          sx={{
            position: 'absolute',
            top: '50%',
            right: 0,
            transform: 'translateY(-50%)',
            opacity: alwaysShowCopyButton ? 1 : 0,
            transition: 'opacity 0.15s',
            color: 'text.secondary',
          }}
        >
          {clipboard.copied ? (
            <CheckRoundedIcon fontSize="small" color="success" />
          ) : (
            <ContentCopyRoundedIcon fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default CopyableChartCaption;
